module.exports = __webpack_public_path__ + "img/RAY.30a30e7b.png";